import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import templateEmptyImage from "@/assets/agent-user-detail/template-empty.webp";

export const TemplateEmptyIcon = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[templateEmptyImage]}
      {...props}
    />
  );
};

TemplateEmptyIcon.displayName = 'TemplateEmptyIcon';
